import React, { useState } from 'react';
import TransactionsTable from './TransactionsTable';
import { sampleTransactions } from '../../../../dummy';

const TransactionsPage = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    if (loading) {
        return (
            <div className="content-body">
                <div className="container-fluid">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="content-body">
                <div className="container-fluid">
                    <div className="alert alert-danger">{error}</div>
                </div>
            </div>
        );
    }

    return (
        <TransactionsTable transactions={sampleTransactions} />
    );
};

export default TransactionsPage;